import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { Box, Button, Link, Modal } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "../../../../../formLayout.scss";
function EndorsementDetailEmployer() {
  const navigate = useNavigate();

  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [memberId, setMemberId] = React.useState("EV001- Vikas Saini");
  const [clientId, setclientId] = React.useState("EV001- Evervent");
  const [insurer, setInsurer] = React.useState("Reliance General Insurance");
  const [endorsementValue, setEndorsementValue] = useState("Address");
  const [endorsementType, setEndorsementType] = useState(
    "Non Commercial Endorsement"
  );
  const [oldValue, setOldValue] = useState(
    "Next57,341,phase 9, Industrial area Mohali, Punjab, India, 160062"
  );
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [attachment, setAttachment] = React.useState(false);
  const [policyId, setpolicyId] = React.useState("PL1421");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("memberdetails");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [buildingaddress, setBuildingNewAddress] = useState(
    "Next62,345,phase 9,"
  );
  const [areaName, setAreaName] = useState("Industrial area");
  const [country, setCountry] = useState("India");
  const [State, setState] = useState("Punjab");
  const [City, setCity] = useState("Chandigarh");
  const [Zipcode, setZipcode] = useState("160030");

  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];

  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];

  // for scrolling
  const personalDetails = useRef(null);
  const endorsementInfo = useRef(null);
  const attatchmentsdetails = useRef(null);
  const memberdetails = useRef(null);
  const endorsementDetails = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === "notes_new_data") {
      setNotesData((notesData) => [
        ...notesData,
        { name: "Umesh", date: new Date(), description: value },
      ]);
    } else {
      attrName(value);
    }
  };

  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homeemployer?page=endorsement");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">E</span>
          <div>
            <h3>Endorsement - Address</h3>
            <p>END 2342</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          {/* <div>
            <Tooltip title="Remove">
              <Link
                
                underline="none"
                className="actionLinks red_icon"
                onClick={() => {
                  setRemoveStatus(true);
                }}
              >
                <DeleteOutlineIcon />
              </Link>
            </Tooltip>
          </div>

          <div>
            <Tooltip title="Global Edit">
              <Link className="actionLinks" onClick={() => {}}>
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div> */}
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Member Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "memberdetails"
                        ? "inner_link active memberdetails"
                        : "inner_link memberdetails"
                    }
                    onClick={() => {
                      setSubSection("memberdetails");
                      handleClicks(subSection);
                      scrollToSection(memberdetails);
                    }}
                  >
                    Member & Policy Details
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "endorsementInfo"
                    ? "active sectionLink endorsementInfo"
                    : "sectionLink endorsementInfo"
                }
                onClick={() => {
                  scrollToSection(endorsementInfo);
                  SetSectionStatus("endorsementInfo");
                }}
              >
                <span> Endorsement Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "endorsementDetails"
                        ? "inner_link active endorsementDetails"
                        : "inner_link endorsementDetails"
                    }
                    onClick={() => {
                      setSubSection("endorsementDetails");
                      handleClicks(subSection);
                      scrollToSection(endorsementDetails);
                    }}
                  >
                    Endorsement Details
                  </Link>
                </li>
              </ul>

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Supporting Documents</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid lg={7} md={7} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>

                    <Button
                      className={
                        viewTabsStatus == "notes"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "notes");
                      }}
                    >
                      Notes
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={5}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 25th July, 2023
                  </p>
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Member Info</h4>
                    </div>
                    <div ref={memberdetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Member & Policy Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={4} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Member ID"
                            value={memberId}
                            attrName={setMemberId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>

                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Client ID"
                            value={clientId}
                            attrName={setclientId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={4} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Policy ID"
                            value={policyId}
                            attrName={setpolicyId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={4} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Insurer"
                            value={insurer}
                            attrName={setInsurer}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={endorsementInfo}>
                    <div className="sectionTitle">
                      <h4>Endorsement Info</h4>
                    </div>
                    <div ref={endorsementDetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Endorsement Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Endorsement Value"
                            value={endorsementValue}
                            attrName={setEndorsementValue}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Endorsement Type"
                            value={endorsementType}
                            attrName={setEndorsementType}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={8} md={8} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Old Personal Address"
                            value={oldValue}
                            attrName={setOldValue}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={12}>
                          <h5 className="mb-0 font-sm">New Personal Address</h5>
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Building/Street Name"
                            value={buildingaddress}
                            value_update={updateMasterState}
                            attrName={setBuildingNewAddress}
                            warn_status={false}
                          />
                        </Grid>

                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="State"
                            value={State}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="City"
                            value={City}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title={"Zipcode"}
                            value={Zipcode}
                            attrName={setZipcode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Supporting Documents </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                </>
              ) : null}

              {viewTabsStatus == "notes" ? (
                <>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={removeStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setRemoveStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to remove this Endorsement.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}
export default EndorsementDetailEmployer;
